import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import {
  colorGrey200,
  colorLink400,
  fontFamilyPrimary,
  mediaQueryMobileLargeMin,
} from '@/styleUtils';

export const ProductCompanyInfo = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  gap: 8px;

  ${({ $isFlatContent }) => {
    if (!$isFlatContent) {
      return css`
        @media ${mediaQueryMobileLargeMin} {
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;
          flex: 0 0 120px;
          width: auto;
        }
      `;
    }

    return css`
      @media ${mediaQueryMobileLargeMin} {
        justify-content: flex-start;
      }
    `;
  }}
`;

export const ProductCompanyLogoBtn = styled(RouterLink)`
  border: 0;
  outline: 0;

  ${({ $isFlatContent }) => {
    if (!$isFlatContent) {
      return css`
        width: 100%;
      `;
    }

    return '';
  }}

  .lazy-load-image-background.opacity {
    transition: opacity 0.3s;

    &:not(.lazy-load-image-loaded) {
      opacity: 0.3;
      height: 48px !important;
    }
  }
`;

export const ProductCompanyRating = styled.span`
  display: flex;

  ${({ $isFlatContent }) => {
    if (!$isFlatContent) {
      return css`
        flex-flow: column;
        gap: 8px;
      `;
    }

    return css`
      align-items: center;
      gap: 12px;
    `;
  }}
`;

export const ProductCompanyLicense = styled.span`
  font: 400 12px/16px ${fontFamilyPrimary};
  color: ${colorGrey200};
`;

export const Link = styled.a`
  color: ${colorLink400};
  font-weight: bold;
  transition: opacity 0.3s ease;
  font-size: 14px;
  line-height: 20px;
  padding: 0 0 8px;
  display: inline-block;

  svg {
    margin-left: 8px;
    opacity: 0.6;
  }

  &:hover,
  &:active {
    opacity: 0.8;
    color: ${colorLink400};
  }
`;

export const TitleTooltip = styled.p`
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 8px;
  text-align: left;
`;

export const DescriptionTooltip = styled.p`
  text-align: left;
  margin-bottom: 8px;
  font-size: 12px;
`;

export const LinkTooltip = styled(Link)`
  font-size: 12px;
  color: #fff;
  text-align: left;
  width: 100%;
  padding: 0;
  font-weight: normal;
  &:hover,
  &:active {
    color: #fff;
  }
`;
